import React from "react";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import "../../styles/brand.css";
import ImageBanner from "../../components/ImageBanner";
import TeamLeadership from "./TeamLeadership";
import TeamExpertise from "./TeamExpertise";
import TeamSupport from "./TeamSupport";
import TeamChecklist from "./TeamChecklist";
import {
  finalCtaContent,
  heroContent,
  leadershipContent,
  teamSeo,
  whyChooseContent,
} from "./teamContent";

const SITE_URL = "https://mbasolutions.co";
/* the document's URL Slug. /team and the legacy /our_team.php still render
   this page; the canonical points every one of them here. */
const CANONICAL = `${SITE_URL}${teamSeo.slug}`;

const buildTeamJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: heroContent.h1,
    description: teamSeo.description,
    url: CANONICAL,
    mainEntity: {
      "@type": "Organization",
      name: "MBA Solutions",
      url: SITE_URL,
      founder: { "@type": "Person", name: leadershipContent.members[0].name },
      employee: leadershipContent.members.map((member) => ({
        "@type": "Person",
        name: member.name,
        jobTitle: member.designation,
        ...(member.image ? { image: `${SITE_URL}${member.image}` } : {}),
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: heroContent.h1, item: CANONICAL },
    ],
  },
];

/* The approved "Our Team Of Experts" document, section for section and in its
   own order, below the page's existing banner video. */
const Team = () => (
  <Layout
    title={teamSeo.title}
    description={teamSeo.description}
    keywords={teamSeo.keywords}
    canonical={CANONICAL}
    jsonLd={buildTeamJsonLd()}
  >
    <main className="team-page brand-page bg-white">
      <ImageBanner
        src="/assets/banners/mba-team.jpeg"
        alt="The MBA Solutions team"
        width={1521}
        height={704}
        whole
      />
      <PageIntro
        id="team-hero-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <TeamLeadership />
      <TeamExpertise />
      <TeamSupport />
      <TeamChecklist
        id="team-why-choose-heading"
        content={whyChooseContent}
        items={whyChooseContent.reasons}
        tone="muted"
      />
      <FinalCtaPanel
        id="team-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        secondaryCta={finalCtaContent.secondaryCta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
);

export default Team;
